import React from 'react';
import PropTypes from 'prop-types';
import { FormItem } from '..';

const validations = ['matchType'];
class SimpleType extends FormItem {
  static propTypes = FormItem.extendPropTypes({ types: PropTypes.object });
  constructor (props) {
    super(props);
    const self = this;
    self.defineValidations(validations);
  }
  getTypes () {
    const self = this;
    return self.props.types;
  }
  validate () {
    const self = this;
    const val = self.getVal();
    const label = self.getItemLabel();
    return new Promise((resolve, reject) => {
      super
        .validate()
        .then(() => {
          if (self.isEmpty()) {
            resolve();
            return;
          }
          if (self.getTypes()[val] == null) {
            reject(`${label}を正しく選択して下さい。`);
            return;
          }
          resolve();
        })
        .catch(reject);
    });
  }
  renderReadonly () {
    const self = this;
    const types = self.getTypes();
    return <p className="mb-0">{types[self.getVal()] || ''}</p>;
  }
  renderInput () {
    const self = this;
    const types = self.getTypes();
    return (
      <div>
        <div>
          {Object.keys(types).map((v, i) => {
            const t = types[v];
            return (
              <div key={`rel-radio-${i}`} className="d-block d-sm-inline-block">
                <label className="custom-control custom-control-inline custom-radio mb-0">
                  <input
                    type="radio"
                    className="custom-control-input"
                    name={self.props.name}
                    value={v}
                    checked={String(self.getVal()) === String(v)}
                    onChange={() => {
                      self.setVal(String(v));
                    }}
                  />
                  <div className="custom-control-label">{t}</div>
                </label>
              </div>
            );
          })}
        </div>
        {self.renderValError()}
      </div>
    );
  }
}
export default SimpleType;
